import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { ActivatedRoute, Router } from '@angular/router';
import { Actions, ofType } from '@ngrx/effects';
import { Store, select } from '@ngrx/store';
import {
  FormActionType,
  Pais,
  TipoRol
} from '@rpe/registro-personas-empresas-lib';
import { Observable, Subscription, combineLatest, forkJoin } from 'rxjs';
import { map, switchMap, take, tap } from 'rxjs/operators';
import {
  FileService,
  NotificationService,
  ROUTE_ANIMATIONS_ELEMENTS
} from '../../../../../core/core.module';
import { Deposito } from '../../../../actividades/entity-depositos/depositos.model';
import { selectAllDepositosFromCurrentEmpresa } from '../../../../actividades/entity-depositos/depositos.selectors';
import { GrupoEspecie } from '../../../../actividades/entity-grupos-especie/grupos-especie.model';
import { Laboratorio } from '../../../../actividades/entity-laboratorios/laboratorios.model';
import { selectAllLaboratoriosFromCurrentEmpresa } from '../../../../actividades/entity-laboratorios/laboratorios.selectors';
import { selectAllMaquinaMovilCurrentEmpresa } from '../../../../actividades/entity-maquinas-moviles/entity-maquina-movil.selectors';
import { MaquinaMovil } from '../../../../actividades/entity-maquinas-moviles/entity-maquinas-moviles.model';
import { SitioProcesamiento } from '../../../../actividades/entity-sitios-procesamiento/sitios-procesamiento.model';
import { selectAllSitiosProcesamientoFromCurrentEmpresa } from '../../../../actividades/entity-sitios-procesamiento/sitios-procesamiento.selectors';
import { selectStepperActividad } from '../../../../actividades/entity-stepper/stepper.selectors';
import { selectViverosGrupoEspecieCurrentEmpresa } from '../../../../actividades/entity-viveros-grupo-especie/entity-viveros-grupo-especie.selectors';
import { ViveroFormInput } from '../../../../actividades/entity-viveros-grupo-especie/models/entity-viveros-grupo-especie.models';
import {
  actividadesLoading,
  selectIsLoadingItems
} from '../../../../navegacion/principal.selectors';
import { Persona } from '../../../../persona/entity-personas/entity-personas.model';
import {
  selectAllPersonas,
  selectAuthPersona
} from '../../../../persona/entity-personas/entity-personas.selectors';
import { selectIntegrantesCurrentEmpresa } from '../../../../roles/entity-integrante/entity-integrante.selectors';
import { entityRolDeleteRequest } from '../../../../roles/entity-roles/entity-roles.actions';
import { selectAllRol } from '../../../../roles/entity-roles/entity-roles.selectors';
import { Rol } from '../../../../roles/entity-roles/roles.model';
import { selectAllTiposRol } from '../../../../roles/entity-tipos-rol/entity-tipos-rol.selectors';
import { Integrante } from '../../../../roles/integrante/integrante.model';
import { State } from '../../../../vista-usuario/vista-usuario.state';
import { entityEntidadesProductivaChangeRequest } from '../../../entity-entidad-productiva/entity-entidades-productiva.actions';
import { EntidadesProductiva } from '../../../entity-entidad-productiva/entity-entidades-productiva.model';
import {
  selectEntidadesProductivaFromCurrentEmpresa,
  selectEntidadesProductivaIsLoading,
  selectEntidadesProductivaState
} from '../../../entity-entidad-productiva/entity-entidades-productiva.selectors';
import { entityCurrentEmpresaSetEmpty } from '../../../entity-mis-empresas/entity-current-empresa.actions';
import { selectAllNaturalezaJuridica } from '../../../entity-naturalezas-juridica/entity-naturalezas-juridica.selectors';
import { NaturalezaJuridica } from '../../../entity-naturalezas-juridica/naturalezas-juridica.model';
import {
  entityPersonasFisicaAddRequest,
  entityPersonasFisicaChangeRequest,
  entityPersonasFisicaChangeSuccess
} from '../../../entity-personas-fisica/entity-personas-fisica.actions';
import {
  PersonaFisicaFormInput,
  RPEPersonaFisica
} from '../../../entity-personas-fisica/entity-personas-fisica.model';
import { selectAllPersonasFisica } from '../../../entity-personas-fisica/entity-personas-fisica.selectors';
import { PersonaFisicaFormComponent } from '../../../entity-personas-fisica/persona-fisica-form/persona-fisica-form.component';
import {
  entityPersonasJuridicaAddRequest,
  entityPersonasJuridicaChangeRequest,
  entityPersonasJuridicaChangeSuccess
} from '../../../entity-personas-juridica/entity-personas-juridica.actions';
import {
  PersonaJuridicaFormInput,
  PersonasJuridica,
  RPEPersonaJuridica
} from '../../../entity-personas-juridica/entity-personas-juridica.model';
import { selectAllPersonasJuridica } from '../../../entity-personas-juridica/entity-personas-juridica.selectors';
import { PersonaJuridicaFormComponent } from '../../../entity-personas-juridica/persona-juridica-form/persona-juridica-form.component';
import { RegistroIntegranteUpdateFormComponent } from '../registro-integrante-update-form/registro-integrante-update-form.component';
import { entityEntidadesProductivaTramiteChangeRequest } from '../../../entidad-productiva-tramite/entidad-productiva-tramite.actions';
import { createMovimientoTramite } from '../../../../tramites/movimiento-tramite/movimiento-tramite.models';
import { selectTramiteRegistroEmpresaFromCurrentEmpresa } from '../../../../tramites/tramite.selectors';
import { Tramite } from '../../../../tramites/tramite.models';
import { movimientoTramiteAddRequest } from '../../../../tramites/movimiento-tramite/movimiento-tramite.actions';
import { selectAllGruposEspecie } from '../../../../actividades/entity-grupos-especie/grupos-especie.selectors';
import { ViveroGrupoEspecie } from '../../../../actividades/entity-viveros-grupo-especie/entity-viveros-grupo-especie.model';
import { esResponsable } from '../../../../roles/entity-roles/roles.utils';

@Component({
  selector: 'rpe-entity-registro-empresa-form-container',
  templateUrl: './entity-registro-empresa-form-container.component.html',
  styleUrls: ['./entity-registro-empresa-form-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EntityRegistroEmpresaFormContainerComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  showCards: boolean = true;
  showLab: boolean = false;
  showSitioProcesamiento: boolean = false;
  showVivero: boolean = false;
  showDeposito: boolean = false;
  showIntegrantes: boolean = false;
  errorComercializacion = false;
  isLinear: boolean = false;
  formValid = false;
  formValidPJ: boolean = false;
  formValidPF: boolean = false;
  hideRegisterButton: boolean = false;

  stepperActividadSubscription: Subscription;
  currentEmpresaSubscription: Subscription;
  spSuscription: Subscription;
  subscriptionGE: Subscription;
  subscriptions: Subscription[] = [];

  grupoEspecie: GrupoEspecie[];

  tramite: Tramite = null;

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;

  @ViewChild('personaFisicaFormComponent')
  personaFisicaFormComponent: PersonaFisicaFormComponent;

  @ViewChild('personaJuridicaFormComponent')
  personaJuridicaFormComponent: PersonaJuridicaFormComponent;

  @ViewChild('stepper') private stepper: MatStepper;

  paises$: Observable<Pais[]> | undefined;

  continuarParam: boolean = false;
  modificarParam: boolean = false;
  isRutValid: boolean = false;
  isLoading$: Observable<boolean>;

  formValueRPEPJ: RPEPersonaJuridica;
  formValueRPEPF: RPEPersonaFisica;

  createdPersonaJuridica: PersonasJuridica = null;
  createdPersonaFisica: Persona = null;

  naturalezasJuridicas: NaturalezaJuridica[] = [];
  roles: Rol[] = [];

  tipoPersonaEmpresa: string = 'persona_juridica';

  //se necesitan dos forminput, para persona juridica, y para persona fisica
  formInputPJ: PersonaJuridicaFormInput = {
    action: FormActionType.Add,
    id_persona_logueada: null,
    tipos_rol: null,
    naturalezas_juridicas: null,
    persona_juridica: null,
    rol: null,
    entidad_productiva: null
  };

  firstFormGroup = this._formBuilder.group({
    firstCtrl: ['', [Validators.required]]
  });

  secondFormGroup = this._formBuilder.group({
    unicamenteComercializacion: [null, [Validators.required]]
  });

  thirdFormGroup = this._formBuilder.group({
    secondCtrl: ['', [Validators.required]]
  });

  fourthFormGroup = this._formBuilder.group({
    secondCtrl: ['', [Validators.required]]
  });

  formInputPF: PersonaFisicaFormInput = {
    action: FormActionType.Add,
    id_persona_logueada: null,
    tipos_rol: null,
    nombre_persona: null,
    documento_persona: null,
    entidadProductiva: null
  };

  get sitiosYMaquinas(): {
    sitios: SitioProcesamiento[];
    maquinasMoviles: MaquinaMovil[];
  } {
    return {
      sitios: this.sitiosProcesamiento,
      maquinasMoviles: this.maquinasMoviles
    };
  }

  laboratorios: Laboratorio[] = [];
  sitiosProcesamiento: SitioProcesamiento[] = [];
  maquinasMoviles: MaquinaMovil[] = [];
  depositos: Deposito[] = [];
  viveros: any[] = [];
  integrantes: Integrante[] = [];
  tiposRol: TipoRol[] = [];
  persona: Persona[] = [];
  authPersona: Persona;

  entidadProductiva: EntidadesProductiva;
  formInputViveros: ViveroFormInput[] = [];
  unicamenteComercializacion: boolean = null;
  comercializacion = false;

  entidadesProductivasIsLoading$: Observable<boolean>;

  get depositosYDependencias(): { deposito: Deposito[]; edit: boolean } {
    return {
      deposito: this.depositos,
      edit: false
    };
  }

  get labsInput(): { data: Laboratorio[]; edit: boolean } {
    return {
      data: this.laboratorios,
      edit: false
    };
  }

  get viverosInput(): { vivero: ViveroFormInput[]; edit: boolean } {
    return {
      vivero: this.viveros.map((vivero) => {
        return {
          vivero: vivero
        } as unknown as ViveroGrupoEspecie;
      }) as unknown as ViveroFormInput[],
      edit: false
    };
  }

  constructor(
    public store: Store<State>,
    private actions$: Actions,
    private ref: ChangeDetectorRef,
    private readonly notificationService: NotificationService,
    private fileService: FileService,
    private dialog: MatDialog,
    private _formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private renderer: Renderer2
  ) {
    this.continuarParam = this.activatedRoute.snapshot.queryParams.continuar;
    this.modificarParam = this.activatedRoute.snapshot.queryParams.modificar;
  }

  get almostOneLaboratorio(): boolean {
    return this.laboratorios.length > 0;
  }

  get almostOneSitioProcesamiento(): boolean {
    return (
      this.sitiosProcesamiento.length > 0 &&
      this.sitiosProcesamiento.some((sitio) => sitio.brinda_servicios_terceros)
    );
  }

  get almostOneMaquinaMovil(): boolean {
    return (
      this.maquinasMoviles.length > 0 &&
      this.maquinasMoviles.some(
        (maquinas) => maquinas.brinda_servicios_terceros
      )
    );
  }

  get analistasForLaboratorio(): boolean {
    let allLabsHasAnalista: boolean = true;

    //para todo lab al menos un analista es necesario

    this.laboratorios.forEach((l) => {
      let hasAnalista = false;

      this.integrantes.forEach((i) => {
        if (i.rol.laboratorios_id) {
          if (i.rol.laboratorios_id.includes(l.id) && i.rol.tipo_rol_id === 7) {
            hasAnalista = true;
          }
        }
      });

      if (!hasAnalista) {
        allLabsHasAnalista = false;
        return;
      }
    });

    return allLabsHasAnalista;
  }

  get almostOneTecnicoResponsable(): boolean {
    // si tiene al menos un laboratorio debe ingresar tambien un tecnico responsable.

    if (this.laboratorios.length > 0) {
      let hasTecnicoResponsable = false;

      //Si ningun sitio procesamienot brinda servicio, no es necesario que haya un tecnico responsable
      if (
        this.sitiosProcesamiento.length > 0 &&
        this.allSitiosProcesamientoNoBrindanServicio
      ) {
        return true;
      }

      this.integrantes.forEach((i) => {
        if (i.rol.tipo_rol_id === 6) {
          hasTecnicoResponsable = true;
        }
      });

      return hasTecnicoResponsable;
    }

    return true;
  }

  get requiereTecnicoResponsableExclusivoComercializacion(): boolean {
    const noExclusivoComercializacion =
      this.entidadProductiva.exclusivo_comercializacion === false;

    const tieneSitiosProcesamiento = this.sitiosProcesamiento.length > 0;
    const allSitiosParaUsoPropio =
      tieneSitiosProcesamiento && this.allSitiosProcesamientoNoBrindanServicio;

    return (
      noExclusivoComercializacion &&
      !allSitiosParaUsoPropio &&
      !this.hasTecnicoResponsable
    );
  }

  get hasTecnicoResponsable(): boolean {
    let hasTecnicoResponsable = false;

    this.integrantes.forEach((i) => {
      if (i.rol.tipo_rol_id === 6) {
        hasTecnicoResponsable = true;
      }
    });

    return hasTecnicoResponsable;
  }

  get allSitiosProcesamientoNoBrindanServicio(): boolean {
    let allNoBrindanServicio: boolean = true;

    this.sitiosProcesamiento.forEach((sp) => {
      if (sp.brinda_servicios_terceros) {
        allNoBrindanServicio = false;
      }
    });

    return allNoBrindanServicio;
  }

  ngAfterViewInit() {
    /* Para ocultar steper header */
    const matHorizontalContainer = document.querySelector(
      '.mat-horizontal-stepper-header-container'
    );
    if (this.modificarParam && matHorizontalContainer) {
      this.renderer.setStyle(matHorizontalContainer, 'display', 'none');
    } else {
      this.renderer.setStyle(matHorizontalContainer, 'display', 'flex');
    }
  }

  ngOnInit(): void {
    if (!this.continuarParam && !this.modificarParam) {
      // Saco el current empresa
      this.store.dispatch(entityCurrentEmpresaSetEmpty());
    }

    const entidadProductivaError = this.store
      .pipe(select(selectEntidadesProductivaState))
      .subscribe((state) => {
        if (state?.error) {
          this.notificationService.error(
            'Error al actualizar la entidad productiva'
          );
          this.hideRegisterButton = false;
        }
      });

    const isLoading$ = this.store.select(selectIsLoadingItems);
    const isActividadesLoading$ = this.store.select(actividadesLoading);
    this.entidadesProductivasIsLoading$ = this.store.select(
      selectEntidadesProductivaIsLoading
    );

    this.isLoading$ = combineLatest([isLoading$, isActividadesLoading$]).pipe(
      map(([isLoading, isActividadesLoading]) => {
        if (!isLoading && !isActividadesLoading) {
          this.showCards = true;
          this.showLab = false;
          this.showSitioProcesamiento = false;
          this.showVivero = false;
          this.showDeposito = false;
          this.showIntegrantes = false;
        }

        return isLoading || isActividadesLoading;
      })
    );

    const sp = this.store
      .pipe(select(selectAuthPersona))
      .subscribe((p) => (this.authPersona = p));
    this.subscriptions.push(sp);
    this.currentEmpresaSubscription = this.store
      .pipe(select(selectEntidadesProductivaFromCurrentEmpresa))
      .pipe(
        map((ep) => {
          this.entidadProductiva = ep[0];
        }),
        switchMap(() => {
          return this.store.select(selectAllPersonasJuridica);
        }),
        tap((pj) => {
          if (pj.length > 0 && this.entidadProductiva) {
            this.createdPersonaJuridica = pj.find(
              (e) => e.id == this.entidadProductiva.id
            )
              ? pj.find((e) => e.id == this.entidadProductiva.id)
              : null;
          }
        }),
        switchMap(() => {
          return this.store.select(selectAllPersonasFisica).pipe(
            switchMap((pf) => {
              return this.store.select(selectAllPersonas).pipe(
                map((p) => {
                  this.persona = p;

                  return pf.map((personaFisica) => {
                    return {
                      ...personaFisica,
                      persona: p.find(
                        (persona) => persona.id === personaFisica.persona_id
                      )
                    };
                  });
                })
              );
            })
          );
        }),
        tap((pf) => {
          if (pf.length > 0 && this.entidadProductiva) {
            this.createdPersonaFisica = pf.find(
              (e) => e.id == this.entidadProductiva.id
            )
              ? pf.find((e) => e.id == this.entidadProductiva.id).persona
              : null;
          }
        }),
        switchMap(() => {
          return this.store.select(selectAllRol).pipe(
            map((roles) => {
              if (this.entidadProductiva) {
                return roles.filter(
                  (rol) =>
                    rol.entidad_productiva_id === this.entidadProductiva?.id
                );
              }

              return roles;
            }),
            tap((roles) => {
              this.roles = roles;
            })
          );
        })
      )
      .subscribe(() => {
        if (this.entidadProductiva) {
          if (this.entidadProductiva.persona_fisica_id) {
            this.tipoPersonaEmpresa = 'persona_fisica';

            this.formInputPF = {
              action: FormActionType.Update,
              id_persona_logueada: this.authPersona.id,
              tipos_rol: this.tiposRol,
              nombre_persona: this.createdPersonaFisica.nombre_completo,
              documento_persona:
                this.createdPersonaFisica.documentos_persona[0],
              entidadProductiva: this.entidadProductiva,
              rol: this.roles.find(
                (rol) =>
                  rol.persona_id === this.authPersona.id && rol.es_creador
              )
            };
          }

          if (this.entidadProductiva.persona_juridica_id) {
            this.tipoPersonaEmpresa = 'persona_juridica';
            this.formInputPJ = {
              action: FormActionType.Update,
              id_persona_logueada: this.authPersona.id,
              tipos_rol: this.tiposRol,
              naturalezas_juridicas: this.naturalezasJuridicas,
              entidad_productiva: this.entidadProductiva,
              persona_juridica: this.createdPersonaJuridica,
              rol: this.roles.find(
                (rol) =>
                  rol.persona_id === this.authPersona.id &&
                  rol.entidad_productiva_id === this.entidadProductiva.id &&
                  esResponsable(rol)
              )
            };
            // si es una actualización selecciono si es exlusivo de comercializacion
            this.unicamenteComercializacion =
              this.entidadProductiva.exclusivo_comercializacion;
            this.comercializacion =
              this.entidadProductiva.comercializacion ?? false;
            this.secondFormGroup.patchValue({
              unicamenteComercializacion: this.unicamenteComercializacion
            });
          }
        }
      });

    this.stepperActividadSubscription = this.store
      .select(selectStepperActividad)
      .pipe(
        tap((s) => {
          if (s === 3 && this.stepper) {
            this.stepper.next();
            this.showLab = false;
            this.showSitioProcesamiento = false;
            this.stepper.previous();
            return;
          }

          if (
            this.stepper &&
            s === 2 &&
            this.getTipoPersonaEmpresa() !== 'persona_fisica'
          ) {
            this.stepper.next();
          }

          if (
            this.stepper &&
            s === 2 &&
            this.getTipoPersonaEmpresa() !== 'persona_juridica'
          ) {
            this.thirdFormGroup.setValue({
              secondCtrl: ['', []]
            });

            this.stepper.next();
          }
        }),
        switchMap(() => {
          return this.store
            .select(selectAllSitiosProcesamientoFromCurrentEmpresa)
            .pipe(
              tap((sitiosProcesamiento) => {
                this.sitiosProcesamiento = sitiosProcesamiento;
              })
            );
        }),
        switchMap(() => {
          return this.store.select(selectAllMaquinaMovilCurrentEmpresa).pipe(
            tap((maquinaMovil) => {
              this.maquinasMoviles = maquinaMovil;
            })
          );
        }),
        switchMap(() => {
          return this.store
            .select(selectAllLaboratoriosFromCurrentEmpresa)
            .pipe(
              tap((laboratorios) => {
                this.laboratorios = laboratorios;
              })
            );
        })
      )
      .subscribe();

    const integrantesSubscription = this.store
      .select(selectIntegrantesCurrentEmpresa)
      .subscribe((integrantes) => {
        this.integrantes = [...integrantes];
        if (
          this.integrantes.length > 0 &&
          !(
            this.almostOneLaboratorio &&
            (!this.analistasForLaboratorio || !this.almostOneTecnicoResponsable)
          )
        ) {
          this.thirdFormGroup.setValue({
            secondCtrl: [this.integrantes, []]
          });
        }
        this.ref.markForCheck();
      });
    this.subscriptions.push(integrantesSubscription, entidadProductivaError);

    let resultado = combineLatest([
      this.store.pipe(select(selectAllTiposRol)),
      this.store.pipe(select(selectAllNaturalezaJuridica)),
      this.store.pipe(select(selectAuthPersona))
    ]).pipe(
      map(
        ([tiposRol, naturalezasJuridicas, persona]) =>
          [tiposRol, naturalezasJuridicas, persona] as [
            TipoRol[],
            NaturalezaJuridica[],
            Persona
          ]
      )
    );
    const s1 = resultado.subscribe(
      ([tiposRol, naturalezasJuridica, persona]) => {
        let tiposRolFiltradosPJ = tiposRol.filter(
          (tipoRol) => tipoRol.pj && !tipoRol.tecnico
        );

        naturalezasJuridica.sort((a, b) => {
          const previousName = a.nombre.toLowerCase();
          const nextName = b.nombre.toLowerCase();

          if (previousName < nextName) {
            return -1;
          }

          if (previousName > nextName) {
            return 1;
          }

          return 0;
        });

        this.naturalezasJuridicas = naturalezasJuridica;

        this.formInputPJ = {
          ...this.formInputPJ,
          id_persona_logueada: persona.id,
          tipos_rol: tiposRolFiltradosPJ,
          naturalezas_juridicas: naturalezasJuridica
        };

        this.tiposRol = tiposRol;

        //se le pasan los datos de la persona porque si es titular se deben cargar los
        //datos de la persona
        let tiposRolFiltradosPF = tiposRol.filter(
          (tipoRol) => tipoRol.pf && !tipoRol.tecnico
        );

        if (!this.continuarParam && !this.modificarParam) {
          this.formInputPF = {
            ...this.formInputPF,
            id_persona_logueada: persona.id,
            tipos_rol: tiposRolFiltradosPF,
            nombre_persona: persona.nombre_completo,
            documento_persona: persona.documentos_persona[0]
          };
        } else {
          this.formInputPF = {
            ...this.formInputPF,
            tipos_rol: tiposRolFiltradosPF
          };
        }
      }
    );
    this.subscriptions.push(s1);

    this.spSuscription = this.store
      .select(selectAllSitiosProcesamientoFromCurrentEmpresa)
      .subscribe((sps) => (this.sitiosProcesamiento = sps));

    //DEPOSITOS
    const s2 = this.store
      .select(selectAllDepositosFromCurrentEmpresa)
      .subscribe((ds) => {
        this.depositos = ds;
      });

    this.subscriptions.push(s2);

    const s3 = this.store
      .select(selectViverosGrupoEspecieCurrentEmpresa)
      .subscribe((ge) => {
        this.viveros = ge;
        this.formInputViveros = ge.map((ge) => {
          return {
            vivero: ge
          };
        });
      });

    this.subscriptions.push(s3);

    // Tramites
    const s4 = this.store
      .select(selectTramiteRegistroEmpresaFromCurrentEmpresa)
      .subscribe((t) => (this.tramite = t));

    this.subscriptions.push(s4);

    // GrupoEspecie
    this.store
      .select(selectAllGruposEspecie)
      .subscribe((data: GrupoEspecie[]) => {
        this.grupoEspecie = data;
      });
  }

  getTipoPersonaEmpresa() {
    return this.tipoPersonaEmpresa;
  }

  handleChangeTipoPersona(event: any) {
    this.tipoPersonaEmpresa = event.value;
  }

  especieById(id: number): GrupoEspecie {
    // return this.espec
    // TODO: obtener especie por id
    return null;
  }

  formStatusChangesPJ(status: string) {
    this.formValidPJ = status === 'VALID';
    this.setFormValid();
  }

  formStatusChangesPF(status: string) {
    this.formValidPF = status === 'VALID';
    this.setFormValid();
  }

  formValueChangesRPEPF(personaFisicaRPE: RPEPersonaFisica) {
    this.formValueRPEPF = personaFisicaRPE;
  }

  formValueChangesRPEPJ(personaJuridicaRPE: RPEPersonaJuridica) {
    this.formValueRPEPJ = personaJuridicaRPE;
  }

  //TODO guardar y esperar para luego hacer el dispatch
  //este metodo debe mejorarse
  save() {
    if (
      this.formValueRPEPJ.rol.acreditacion_representacion &&
      this.formValueRPEPJ.persona_juridica.certificado_notarial
    ) {
      forkJoin([
        this.fileService.uploadFile(
          this.formValueRPEPJ.rol.acreditacion_representacion
        ),
        this.fileService.uploadFile(
          this.formValueRPEPJ.persona_juridica.certificado_notarial
        )
      ]).subscribe((results) => {
        this.formValueRPEPJ = {
          ...this.formValueRPEPJ,
          rol: {
            ...this.formValueRPEPJ.rol,
            acreditacion_representacion: results[0]
          },
          persona_juridica: {
            ...this.formValueRPEPJ.persona_juridica,
            certificado_notarial: results[1]
          }
        };
        this.store.dispatch(
          entityPersonasJuridicaAddRequest({
            item: this.formValueRPEPJ
          })
        );
      });
    } else if (this.formValueRPEPJ.rol.acreditacion_representacion) {
      this.fileService
        .uploadFile(this.formValueRPEPJ.rol.acreditacion_representacion)
        .subscribe((result) => {
          this.formValueRPEPJ = {
            ...this.formValueRPEPJ,
            rol: {
              ...this.formValueRPEPJ.rol,
              acreditacion_representacion: result
            }
          };
          this.store.dispatch(
            entityPersonasJuridicaAddRequest({
              item: this.formValueRPEPJ
            })
          );
        });
    } else if (this.formValueRPEPJ.persona_juridica.certificado_notarial) {
      this.fileService
        .uploadFile(this.formValueRPEPJ.persona_juridica.certificado_notarial)
        .subscribe((result) => {
          this.formValueRPEPJ = {
            ...this.formValueRPEPJ,
            persona_juridica: {
              ...this.formValueRPEPJ.persona_juridica,
              certificado_notarial: result
            }
          };
          this.store.dispatch(
            entityPersonasJuridicaAddRequest({
              item: this.formValueRPEPJ
            })
          );
        });
    } else {
      this.store.dispatch(
        entityPersonasJuridicaAddRequest({
          item: this.formValueRPEPJ
        })
      );
    }
  }

  isFile(file: any): boolean {
    return file && file._files && file._files.length > 0;
  }

  update() {
    let data: RPEPersonaJuridica = {
      ...this.formValueRPEPJ,
      persona_juridica: {
        ...this.formValueRPEPJ.persona_juridica,
        id: this.createdPersonaJuridica.id,
        certificado_notarial:
          this.formValueRPEPJ.persona_juridica.certificado_notarial
      },
      rol: {
        ...this.formValueRPEPJ.rol,
        acreditacion_representacion:
          this.formValueRPEPJ.rol.acreditacion_representacion
      }
    };

    delete data.rol.acreditacion_representacion;
    delete data.persona_juridica.certificado_notarial;

    if (
      !this.isFile(this.formValueRPEPJ.rol.acreditacion_representacion) &&
      !this.isFile(this.formValueRPEPJ.persona_juridica.certificado_notarial)
    ) {
      this.store.dispatch(
        entityPersonasJuridicaChangeRequest({
          item: data
        })
      );
      return;
    }

    if (
      this.formValueRPEPJ.rol.acreditacion_representacion &&
      this.formValueRPEPJ.persona_juridica.certificado_notarial &&
      this.isFile(this.formValueRPEPJ.rol.acreditacion_representacion) &&
      this.isFile(this.formValueRPEPJ.persona_juridica.certificado_notarial)
    ) {
      forkJoin([
        this.fileService.uploadFile(
          this.formValueRPEPJ.rol.acreditacion_representacion
        ),
        this.fileService.uploadFile(
          this.formValueRPEPJ.persona_juridica.certificado_notarial
        )
      ]).subscribe((results) => {
        data = {
          ...data,
          rol: {
            ...data.rol,
            acreditacion_representacion: results[0]
          },
          persona_juridica: {
            ...data.persona_juridica,
            certificado_notarial: results[1]
          }
        };
        this.store.dispatch(
          entityPersonasJuridicaChangeRequest({
            item: {
              ...data,
              persona_juridica: {
                ...data.persona_juridica,
                id: this.createdPersonaJuridica.id
              }
            }
          })
        );
      });
    } else if (
      this.formValueRPEPJ.rol.acreditacion_representacion &&
      this.isFile(this.formValueRPEPJ.rol.acreditacion_representacion)
    ) {
      this.fileService
        .uploadFile(this.formValueRPEPJ.rol.acreditacion_representacion)
        .subscribe((result) => {
          data = {
            ...data,
            rol: {
              ...data.rol,
              acreditacion_representacion: result
            }
          };
          this.store.dispatch(
            entityPersonasJuridicaChangeRequest({
              item: data
            })
          );
        });
    } else if (
      this.formValueRPEPJ.persona_juridica.certificado_notarial &&
      this.isFile(this.formValueRPEPJ.persona_juridica.certificado_notarial)
    ) {
      this.fileService
        .uploadFile(this.formValueRPEPJ.persona_juridica.certificado_notarial)
        .subscribe((result) => {
          data = {
            ...data,
            persona_juridica: {
              ...data.persona_juridica,
              certificado_notarial: result
            }
          };
          this.store.dispatch(
            entityPersonasJuridicaChangeRequest({
              item: data
            })
          );
        });
    }
  }

  setFormValid() {
    if (this.getTipoPersonaEmpresa() === 'persona_juridica') {
      this.formValid = this.formValidPJ;
    } else {
      this.formValid = this.formValidPF;
    }
  }

  onSubmitPersonaJuridica() {
    if (!this.isRutValid) {
      this.notificationService.error('Debe ingresar un RUT válido');
      return;
    }

    if (this.formValid) {
      this.firstFormGroup.setValue({
        firstCtrl: this.formValueRPEPJ
      });
      if (this.formInputPJ.action === FormActionType.Add) {
        this.save();
      } else if (this.formInputPJ.action === FormActionType.Update) {
        this.update();
        if (this.modificarParam) {
          this.modificarParam = false;
          this.actions$.pipe(
            ofType(entityPersonasJuridicaChangeSuccess),
            take(1)
          ).subscribe(() => {
            this.router.navigateByUrl('empresas/mi-empresa');
          });
        }
      }
    } else {
      this.notificationService.error(
        'Debe corregir los errores en el formulario'
      );
      this.personaJuridicaFormComponent?.onShowErrors();
    }
  }

  onSubmitPersonaFisica() {
    if (this.formValid) {
      this.firstFormGroup.setValue({
        firstCtrl: this.formValueRPEPF
      });
      if (this.formInputPF.action === FormActionType.Add) {
        this.onAddPersonaFisica();
      } else if (this.formInputPF.action === FormActionType.Update) {
        this.onUpdatePersonaFisica();
        if (this.modificarParam) {
          this.modificarParam = false;
          this.actions$.pipe(
            ofType(entityPersonasFisicaChangeSuccess),
            take(1)
          ).subscribe(() => {
            this.router.navigateByUrl('empresas/mi-empresa');
          });
        }
      }
    } else {
      this.notificationService.error(
        'Debe corregir los errores en el formulario'
      );
      this.personaFisicaFormComponent.onShowErrors();
    }
  }

  onUpdatePersonaFisica(): void {
    let data: RPEPersonaFisica = {
      ...this.formValueRPEPF,
      rol: {
        ...this.formValueRPEPF.rol,
        acreditacion_representacion:
          this.formValueRPEPF.rol.acreditacion_representacion
      }
    };

    delete data.rol.acreditacion_representacion;

    if (!this.isFile(this.formValueRPEPF.rol.acreditacion_representacion)) {
      this.store.dispatch(
        entityPersonasFisicaChangeRequest({
          item: data
        })
      );
      return;
    }

    if (this.isFile(this.formValueRPEPF.rol.acreditacion_representacion)) {
      this.fileService
        .uploadFile(this.formValueRPEPF.rol.acreditacion_representacion)
        .subscribe((result) => {
          this.formValueRPEPF = {
            ...this.formValueRPEPF,
            rol: {
              ...this.formValueRPEPF.rol,
              acreditacion_representacion: result
            }
          };
          this.store.dispatch(
            entityPersonasFisicaChangeRequest({
              item: this.formValueRPEPF
            })
          );
        });
    }
  }

  onAddPersonaFisica(): void {
    if (this.formValueRPEPF.rol.acreditacion_representacion) {
      this.fileService
        .uploadFile(this.formValueRPEPF.rol.acreditacion_representacion)
        .subscribe((result) => {
          this.formValueRPEPF = {
            ...this.formValueRPEPF,
            rol: {
              ...this.formValueRPEPF.rol,
              acreditacion_representacion: result
            }
          };
          this.store.dispatch(
            entityPersonasFisicaAddRequest({
              item: this.formValueRPEPF
            })
          );
        });
    } else {
      this.store.dispatch(
        entityPersonasFisicaAddRequest({
          item: this.formValueRPEPF
        })
      );
    }
  }

  onSubmit() {
    if (this.getTipoPersonaEmpresa() === 'persona_juridica') {
      this.onSubmitPersonaJuridica();
    } else if (this.getTipoPersonaEmpresa() === 'persona_fisica') {
      this.onSubmitPersonaFisica();
    }
  }

  ngOnDestroy(): void {
    this.currentEmpresaSubscription.unsubscribe();
    this.stepperActividadSubscription.unsubscribe();
    this.spSuscription.unsubscribe();
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  rutStatusChange(isValid: boolean): void {
    this.isRutValid = isValid;
    this.ref.markForCheck();
  }

  // marca para deteccion de cambios cuando cambia el estado de carga de dgi
  onDGILoadedChange(loaded: boolean): void {
    this.ref.markForCheck();
  }

  // determina si mostrar los botones de accion
  shouldShowActions(): boolean {
    if (this.getTipoPersonaEmpresa() === 'persona_fisica') {
      return true;
    }
    
    if (this.getTipoPersonaEmpresa() === 'persona_juridica') {
      return this.isRutValid && this.personaJuridicaFormComponent?.mostrarFormularioCompleto;
    }
    
    return false;
  }

  // determina si mostrar el boton volver
  shouldShowVolverButton(): boolean {
    if (this.getTipoPersonaEmpresa() === 'persona_juridica' && 
        this.formInputPJ.action === FormActionType.Add) {
      return true;
    }
    return false;
  }

  // determina si mostrar el boton cancelar
  shouldShowCancelButton(): boolean {
    const isUpdate = this.formInputPJ.action === FormActionType.Update || 
                     this.formInputPF.action === FormActionType.Update;
    const isPersonaFisica = this.getTipoPersonaEmpresa() === 'persona_fisica';
    
    return isUpdate || isPersonaFisica;
  }

  // vuelve al estado inicial del formulario mostrando solo el rut
  volver(): void {
    if (this.getTipoPersonaEmpresa() === 'persona_juridica' && 
        this.formInputPJ.action === FormActionType.Add &&
        this.personaJuridicaFormComponent) {
      this.personaJuridicaFormComponent.resetToRutOnly();
      this.ref.markForCheck();
    }
  }

  updateIntegrante(integrante: Integrante) {
    this.dialog.open(RegistroIntegranteUpdateFormComponent, {
      data: {
        integrante: integrante,
        laboratorios: this.laboratorios,
        personaJuridica: this.createdPersonaJuridica,
        personaFisica: this.createdPersonaFisica,
        naturalezasJuridicas: this.naturalezasJuridicas
      }
    });
  }

  deleteIntegrante(integrante: Integrante) {
    this.store.dispatch(entityRolDeleteRequest({ item: integrante }));
  }

  findRol(id: number): TipoRol {
    return this.tiposRol.find((tipoRol) => tipoRol.id === id);
  }

  saveRegister(): void {
    this.hideRegisterButton = true;
    // Si esta en estado 1, creacion de nueva empresa
    if (this.entidadProductiva.estado == 1) {
      this.store.dispatch(
        entityEntidadesProductivaTramiteChangeRequest({
          item: { ...this.entidadProductiva, estado: 2 }
        })
      );
    } else {
      // Si esta en estado 2, ese correccion de algo que falto
      if (this.entidadProductiva.estado == 2) {
        const item = createMovimientoTramite({
          tramite_id: this.tramite?.id,
          asignado_id: null,
          success: true,
          fecha_completado: null,
          observacion: null,
          estado_id: null
        });
        this.store.dispatch(
          movimientoTramiteAddRequest({
            item
          })
        );
      }
    }
  }

  onChangeLabStep() {
    if (!this.laboratorios.length) {
      this.thirdFormGroup.setValue({
        secondCtrl: ['', []]
      });
    }

    if (this.unicamenteComercializacion == null) {
      this.errorComercializacion = true;
      return;
    }

    this.stepper.next();
  }

  onChangeIntegrantesStep() {
    if (this.requiereTecnicoResponsableExclusivoComercializacion) {
      this.notificationService.error(
        'Debe ingresar al menos un Técnico/a Responsable'
      );
      return;
    }

    if (this.almostOneLaboratorio && !this.almostOneTecnicoResponsable) {
      this.notificationService.error(
        'Debe ingresar al menos un Técnico/a Responsable'
      );
      return;
    }

    if (this.almostOneSitioProcesamiento && !this.hasTecnicoResponsable) {
      this.notificationService.error(
        'Debe ingresar al menos un Técnico/a Responsable'
      );
      return;
    }

    if (this.almostOneMaquinaMovil && !this.hasTecnicoResponsable) {
      this.notificationService.error(
        'Debe ingresar al menos un Técnico/a Responsable'
      );
      return;
    }

    if (this.almostOneLaboratorio && !this.analistasForLaboratorio) {
      this.notificationService.error(
        'Debe ingresar al menos un Analista por laboratorio'
      );
      return;
    }

    this.stepper.next();
  }

  showPersonaJuridica(): boolean {
    return this.getTipoPersonaEmpresa() === 'persona_juridica';
  }

  showPersonaFisica(): boolean {
    return this.getTipoPersonaEmpresa() === 'persona_fisica';
  }

  parseNaturalezJuridica(id: number): NaturalezaJuridica {
    return this.naturalezasJuridicas.find((nj) => nj.id === id);
  }

  onUnicamenteComercializacion(e: any) {
    this.errorComercializacion = false;
    this.unicamenteComercializacion = e.value;
    this.secondFormGroup.patchValue({
      unicamenteComercializacion: this.unicamenteComercializacion
    });
    // Si la empresa es exclusiva de comercializacion, comercializa por definicion.
    if (e.value) {
      this.comercializacion = true;
    }

    const entidad = {
      ...this.entidadProductiva,
      exclusivo_comercializacion: e.value,
      comercializacion: this.comercializacion
    };
    this.store.dispatch(
      entityEntidadesProductivaChangeRequest({ item: entidad })
    );
  }

  onComercializacion(checked: boolean): void {
    this.comercializacion = checked;

    const entidad = {
      ...this.entidadProductiva,
      comercializacion: checked
    };
    this.store.dispatch(
      entityEntidadesProductivaChangeRequest({ item: entidad })
    );
  }

  buscarNombreEspecie(ids: number[] | null): string[] {
    if (ids == null) {
      return [];
    }

    const nombresEspecies: string[] = [];

    ids.forEach((id) => {
      const especie = this.grupoEspecie.find((e) => e.id === id);
      if (especie) {
        nombresEspecies.push(especie.nombre);
      } else {
        nombresEspecies.push(`Especie con ID ${id} no encontrada`);
      }
    });

    return nombresEspecies;
  }
}
